module.exports = {
    secondView: "second-view",

    noBorder: "no-border",

    cardRegion: "card-region",
    cardRegionBorder: "card-region-border",
    cardRegionOverlay: "region-connection-overlay",

    arrowHeadStart: "arrow-head-start",
    arrowHeadEnd: "arrow-head-end",

    card: "card",
    regionCard: "region-card",
    shortCard: "short-card",
    tableCard: "table-card",
    tableHeader: "table-header",
    colMinWidth: "min-width",
    colFadeIn: "col-fade-in",

    tableCardTitle: "title",

    faIcon: "fa",
    iconCategory: "fa-tag",
    iconUser: "fa-user",
    iconShare: "fa-share",
    iconTimePassed: "fa-clock-o",
    iconRemove: "fa-times",

    toolbar: "toolbar",
    expander: "expander",

    disabled: "disabled",
    selected: "selected",
    noInteraction: "no-interaction",

    popupContainer: "popup-container",
    popup: "popup",
    popupDialog: "popup-dialog",

    contextMenu: "context-menu",
    contextMenuItem: "context-menu-item",

    fitToContent: "fit",

    hoverBgBlue: "hover:bg-blue",
};
